export default {"src":"/_next/static/image/src/images/account/icon-connect-to-vet.253bf8b6946ec20413b4c3f7ab86d1df.svg","height":96,"width":96};